import React from 'react';
import { storyblokEditable, StoryblokComponent } from 'gatsby-source-storyblok';
import Breadcrumb from '../content/breadcrumb';

const DestinationPage = ({
  blok,
  hotels,
  price,
  priceType,
  breadcrumbs,
  currentStoryInternalId,
}) => {
  return (
    <main
      {...storyblokEditable(blok)}
      className="grid grid-cols-12 gap-x-4 max-w-screen-xl mx-auto -pt-[1rem] px-2 md:px-4"
    >
      <Breadcrumb blok={blok} breadcrumbs={breadcrumbs} />
      <div
        className="col-span-12 px-4 md:px-8 mt-0 mb-2"
        {...storyblokEditable(blok)}
      >
        <h1 className="text-lg lg:text-2xl p-0">{blok.title}</h1>
      </div>
      {blok &&
        blok.body &&
        blok.body.map((nestedBlok) => (
          <StoryblokComponent
            blok={nestedBlok}
            key={nestedBlok._uid}
            hotels={hotels}
            price={price}
            priceType={priceType}
            destination={blok.destination_id}
            season={blok.season}
            currentStoryInternalId={currentStoryInternalId}
          />
        ))}
    </main>
  );
};

export default DestinationPage;
